module.exports = __webpack_public_path__ + "img/novo-nordisk.e33bf309.jpg";